module.exports = __webpack_public_path__ + "static/media/shiv.e1c97522.jpeg";